import React, { useState, useContext, Fragment } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@mui/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { CreditScoreOutlined, ExpandMore } from "@mui/icons-material";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import axios from "axios";
import {
  Box,
  Grid,
  Alert,
  Dialog,
  DialogContent,
  DialogActions,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import ExcelProductsTotalReport from "views/Print/ExcelProductsTotalReport";

import loaderGif from "assets/img/loading.gif";
import noDataImg from "assets/img/undraw_House_searching_re_stk8.png";

import {
  cardBodyStyle,
  ButtonStyle0,
  ButtonExit,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function ReportTransactionsProductsList(props) {
  const classes = useStyles();

  const [toDate, setToDate] = useState();
  const [fromDate, setFromDate] = useState();
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [products, setProducts] = React.useState([]);

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const handleFromDateChange = (data) => {
    setFromDate(data);

    // Si la nueva fecha "Desde" es mayor que "Hasta", restablece "Hasta"
    if (data && toDate && data.isAfter(toDate)) {
      setToDate(null);
    } else {
      setToDate(null);
    }
  };

  const handleToDateChange = (data) => {
    setToDate(data);
  };

  const handleResponseData = (data) => {
    return data.map((item) => ({
      ...item,
      productsJson: parseJsonArray(item.productsJson),
      dependentsJson: parseJsonArray(item.dependentsJson),
    }));
  };

  const RefreshTable = async () => {
    setLoader(true);

    try {
      const response = await axios.get(
        `${urlServices}clients-transaction/list/company`,
        {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        }
      );

      if (response.status === 200) {
        const transformedRows = handleResponseData(response.data);

        const responseData = transformedRows.filter(
          (client) =>
            client.paymentTransactions.length > 0 &&
            client.paymentTransactions.some(
              (transaction) => transaction.status === 1
            ) // Verificamos que al menos una transacción no tenga status 1
        );

        let filteredRows = responseData;

        const responseData1 = transformedRows.filter(
          (client) => client.cashPaymentTransactions.length > 0
        );

        filteredRows = [...filteredRows, ...responseData1];

        if (fromDate && toDate) {
          // Convertir las fechas de fromDate y toDate a formato 'YYYY-MM-DD'
          const fromDateValue = dayjs(fromDate).format("YYYY-MM-DD");
          const toDateValue = dayjs(toDate).format("YYYY-MM-DD");

          // Filtrar los registros por el rango de fechas
          filteredRows = filteredRows.filter((item) => {
            const createdAt = dayjs(item.createdAt).format("YYYY-MM-DD");

            // Verifica si createdAt está dentro del rango entre fromDate y toDate
            return createdAt >= fromDateValue && createdAt <= toDateValue;
          });
        }

        filteredRows = filteredRows.filter((client) => client.status === 1);

        // Crear un objeto para almacenar los productos únicos (usando product.id o product.name)
        const uniqueProducts = {};
        const uniqueProductsSelect = {};

        // Iterar sobre los elementos de filteredRows para agregar los productos
        filteredRows.forEach((item) => {
          if (item.product && item.product.id) {
            // Usamos product.id como clave en el objeto para asegurarnos de que solo guardamos productos únicos
            uniqueProducts[item.product.id] = {
              id: item.product.id,
              name: item.product.name,
              prices: parseJsonArray(item.product.prices),
            };
          }
        });

        // Convertir el objeto uniqueProducts a un array
        const finalProducts = Object.values(uniqueProducts);

        finalProducts.forEach((item0) => {
          item0.prices.forEach((item1) => {
            let countItem = 0;
            let priceTotal = 0;

            filteredRows.forEach((item2) => {
              if (
                item0.id === item2.product.id &&
                item1.price === item2.productsJson[0].priceSelect
              ) {
                countItem += 1;
                priceTotal +=
                  item2.productsJson[0].typePay === "CR"
                    ? parseFloat(item2.productsJson[0].payMonthTotal)
                    : parseFloat(item2.productsJson[0].payTotal);
              }
            });

            uniqueProductsSelect[item1.name] = {
              name: item1.name,
              count: countItem,
              priceTotal: parseFloat(priceTotal).toFixed(2),
            };
          });

          // Convertir el objeto uniqueProductsSelect a un array
          const finalItems = Object.values(uniqueProductsSelect);
          item0.dataSelect = finalItems;
        });

        // Establecer los productos obtenidos de manera única

        setProducts(finalProducts);
        setTotalRows(filteredRows.length);
        setRows(filteredRows);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);
        setTimeout(() => {
          localStorage.clear();
          setReturnLogin(true);
        }, 4000);
      } else if (error.response?.status === 500) {
        setRows([]);
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      } else {
        console.error("Error en la solicitud:", error);
        setRows([]);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }
    } finally {
      setLoader(false);
    }
  };

  // Función para parsear cadenas JSON y asegurar que sean arrays
  const parseJsonArray = (jsonString) => {
    try {
      const parsed = JSON.parse(jsonString);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return [];
    }
  };

  const handleSearch = () => () => {
    RefreshTable();
  };

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      aria-labelledby="customized-dialog-title"
      open={props.open}
      keepMounted
      scroll="body"
      PaperProps={{
        sx: {
          borderRadius: 6,
        },
      }}
    >
      <DialogContent dividers className={classes.styleDialogContent}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <div className={classes.cardTitleBlack}>
              <CreditScoreOutlined className={classes.iconFilter} /> Reporte de
              transacciones totales por productos
            </div>
            <Card>
              <CardBody>
                {error ? <Alert severity="error">{mensageSystem}</Alert> : ""}
                {loader ? (
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                      <center>
                        <img
                          alt="loaderGif"
                          src={loaderGif}
                          style={{ width: 60, margin: "20% 0" }}
                        />
                      </center>
                    </Grid>
                  </Grid>
                ) : (
                  <Fragment>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12}>
                        <div
                          className={classes.cardTitleBlack}
                          style={{ fontSize: 14 }}
                        >
                          Filtros:
                        </div>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={["DatePicker"]}>
                            <DatePicker
                              name="fromDate"
                              label="Desde"
                              value={fromDate}
                              onChange={(newValue) =>
                                handleFromDateChange(newValue)
                              }
                              format="DD/MM/YYYY"
                              sx={{
                                "& .MuiButtonBase-root": {
                                  color: "#333",
                                },
                                width: "100%",
                                background: "#FFFFFF",
                              }}
                              slotProps={{
                                textField: {
                                  // helperText: "DD/MM/YYYY",
                                  //  required: true,
                                  size: "small",
                                },
                              }}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={["DatePicker"]}>
                            <DatePicker
                              name="toDate"
                              label="Hasta"
                              value={toDate}
                              onChange={(newValue) =>
                                handleToDateChange(newValue)
                              }
                              format="DD/MM/YYYY"
                              sx={{
                                "& .MuiButtonBase-root": {
                                  color: "#333",
                                },
                                width: "100%",
                                background: "#FFFFFF",
                              }}
                              slotProps={{
                                textField: {
                                  // helperText: "DD/MM/YYYY",
                                  //  required: true,
                                  size: "small",
                                },
                              }}
                              disabled={fromDate ? false : true}
                              minDate={fromDate ? fromDate : null}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={6} sm={3}>
                        <ButtonStyle0
                          style={{ fontSize: 12, width: 130, marginTop: 10 }}
                          onClick={handleSearch()}
                        >
                          {fromDate ? "Buscar filtro" : "Buscar todo"}
                        </ButtonStyle0>
                      </Grid>
                      <Grid item xs={6} sm={3}>
                        <Box style={{ float: "right" }}>
                          <span
                            className={classes.cardTitleBlack}
                            style={{ fontSize: 14, marginRight: 20 }}
                          >
                            Total registro{totalRows > 1 ? "s" : ""}:
                            {" " + totalRows}
                          </span>
                          <center>
                            <ExcelProductsTotalReport
                              fromDate={fromDate}
                              toDate={toDate}
                              excelData={products}
                              fileName={`Exportar_excel_productos_total`}
                              disabled={rows.length > 0 ? false : true}
                            />
                          </center>
                        </Box>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      {rows.length > 0 ? (
                        <>
                          <Grid item xs={12} sm={12}>
                            <div
                              className={classes.cardTitleBlack}
                              style={{
                                fontSize: 12,
                                margin: "20px 10px 10px 10px",
                                color: "#000",
                              }}
                            >
                              RESULTADOS:
                            </div>
                          </Grid>
                          {products.map((data) => (
                            <Grid item xs={12} sm={4} key={data.id}>
                              <Accordion defaultExpanded>
                                <AccordionSummary
                                  expandIcon={<ExpandMore />}
                                  aria-controls="panel1-content"
                                  id="panel1-header"
                                  sx={{
                                    background: "papayawhip",
                                  }}
                                >
                                  <div
                                    className={classes.cardTitleBlack}
                                    style={{ fontSize: 12 }}
                                  >
                                    {data.name}
                                  </div>
                                </AccordionSummary>
                                <AccordionDetails>
                                  {data.dataSelect.map((data0) => (
                                    <div
                                      key={data0.name}
                                      style={{ marginBottom: "10px" }}
                                    >
                                      <div
                                        className={classes.cardTitleBlack}
                                        style={{ fontSize: 12 }}
                                      >
                                        {data0.name}:
                                      </div>
                                      <div
                                        style={{
                                          background: "#F6F6F6",
                                          padding: "6px 10px",
                                          borderRadius: "4px",
                                          fontSize: 14,
                                          color:
                                            parseInt(data0.count) >= 1
                                              ? "green"
                                              : "red",
                                          fontWeight: 500,
                                        }}
                                      >
                                        <div>
                                          <b
                                            style={{
                                              fontSize: 10,
                                              marginRight: 8,
                                              color: "#000",
                                            }}
                                          >
                                            Total registro
                                            {parseInt(data0.count) > 1
                                              ? "s"
                                              : ""}
                                            :
                                          </b>{" "}
                                          {data0.count}
                                        </div>
                                        <div>
                                          <b
                                            style={{
                                              fontSize: 10,
                                              marginRight: 8,
                                              color: "#000",
                                            }}
                                          >
                                            Sumatoria total:
                                          </b>{" "}
                                          ${data0.priceTotal}
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </AccordionDetails>
                              </Accordion>
                            </Grid>
                          ))}
                        </>
                      ) : (
                        <Grid item xs={12} sm={12}>
                          <center>
                            <img
                              alt="loaderGif"
                              src={noDataImg}
                              style={{ width: 300, marginTop: 50 }}
                            />
                            <br></br>
                            <b style={{ fontSize: 18, margin: "5px 0 70px 0" }}>
                              No hay registros para mostrar
                            </b>
                          </center>
                        </Grid>
                      )}
                    </Grid>
                  </Fragment>
                )}
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </DialogContent>
      <DialogActions>
        <ButtonExit onClick={handleCloseDialog()}>Cerrar</ButtonExit>
      </DialogActions>
    </Dialog>
  );
}
